'use strict';

import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import cn from 'classnames/bind';

import { appSelectors, appOperations } from '@/state/domains/app';
import { usersSelectors, usersOperations } from '@/state/domains/users';

import s from './styles.scss';
import m from '../styles.scss';

export default connect(
	(state, props) => ({
		modals: appSelectors.getModalStates(state, props),
		modalProps: appSelectors.getModalProps(state, props),
	}),
	{
		setModalClose: appOperations.setModalClose,
		deleteUser: usersOperations.deleteUser,
	}
)(
	({
		modals,
		modalProps,
		deleteUser,
		setModalClose,
	}) => {

		const { user, removeUser } = modalProps;

		const proceedDeleteUser = () => {

			deleteUser(user._id).then(r => {
				if (r.success) {
					removeUser(r.data.user);
					setModalClose('deleteUser');
				}
			}).catch(e => {
			});
		};

		return (
			<Modal
				appElement={ document.getElementById('root') }
				overlayClassName={ m.modalOverlay }
				isOpen={ modals.deleteUser }
				contentLabel='Confirm Delete'
				shouldCloseOnOverlayClick={ true }
				shouldCloseOnEsc={ true }
				onRequestClose={ () => setModalClose('deleteUser') }
				className={ m.modal }
			>
				<div className={ s.root }>
					<header>Delete User</header>

					<p className={ s.subject }>
						{ `${ user.firstName } ${ user.lastName }` }
					</p>
					<div className={ m.btns }>
						<button
							onClick={ () => setModalClose('deleteUser') }
							className={ m.cancel }
						>
							Cancel
						</button>
						<button
							onClick={ proceedDeleteUser }
							className={ m.proceedRed }
						>
							Delete
						</button>
					</div>
				</div>
			</Modal>
		);
	}
);
